import api from "../../http";

export default class ApiIndexPlatforms {
  static async getApiIndexTechnology(url) {
    return api.get(url)
  }
}